import { HttpClient } from '@angular/common/http';
import { effect, Injectable, signal } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

const USER_API = environment.BASE_URL + 'userApi/';
const SIDEBAR_EXPANDED_STORAGE_KEY = 'sidebar.expanded';

@Injectable({
    providedIn: 'root',
})
export class SidebarService {
    public readonly isExpanded = signal<boolean>(this.readInitialExpandedState());

    constructor(private http: HttpClient) {
        effect(() => {
            const expanded = this.isExpanded();
            localStorage.setItem(SIDEBAR_EXPANDED_STORAGE_KEY, JSON.stringify(expanded));
        });
    }

    public toggleExpanded(): void {
        this.isExpanded.update((expanded) => !expanded);
    }

    public getHelpPageToken(): Observable<string> {
        return this.http.post<string>(`${USER_API}user/get-docs-token`, {}, { responseType: 'text' as 'json' });
    }

    private readInitialExpandedState(): boolean {
        try {
            const storedValue = localStorage.getItem(SIDEBAR_EXPANDED_STORAGE_KEY);
            return storedValue === null ? false : (JSON.parse(storedValue) as boolean);
        } catch {
            return false;
        }
    }
}
